// import React, { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { FiArrowLeft, FiCalendar, FiCreditCard, FiPackage, FiSearch, FiShoppingBag, FiUser, FiX } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import useCurrentStock from '../../../../hooks/useCurrentStock';
import { useRef } from 'react';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import beep from '../../../../assets/audio/beep.mp3';
import CustomerList from '../../../../hooks/CustomerList';
import Loader from '../../../Shared/Loader';
import useCurrentStockWithoutSearch from '../../../../hooks/useCurrentStockWithoutSearch';
import useCurrentStockForPosSale from '../../../../hooks/useCurrentStockForPosSale';
import { nextTenantNumber, useTenantNumbering } from '../../../../saas/tenantNumbering';
import './AddPosSalesMobile.css';

const AddPosSales = () => {
    const tenantNumbering = useTenantNumbering();
    const { posCustomer } = useSelector((state) => state.salesInvoice);
    const userAc = useSelector((state) => state.user.user);
    const products = useSelector((state) => state.purchaseOrder.products);
    const [searchText, setSearchText] = useState();

    const handleSearchTermChange = (event) => {
        const value = event?.target?.value || '';
        setSearchTerm(value);
        setIsSearching(Boolean(value.trim()));
    };


    const { isSearching, setIsSearching, searchTerm, setSearchTerm, filtered, isLoading } = useCurrentStockForPosSale();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobileCheckout = location.pathname === '/mobile/addpossales';

    useEffect(() => {
        const exactMatch = filtered.find(product => product.code === searchTerm);
        if (exactMatch) {
            // If an exact match is found, trigger the addProductToInvoice function
            handleAddProductToInvoice(exactMatch);
            setSearchTerm('');
            setIsSearching(false);
        }
    }, [filtered, searchTerm, setIsSearching]);

    const [isPayment, setIsPayment] = useState(false);
    const [isDiscount, setIsDiscount] = useState(false);
    const [discountAmount, setDiscountAmount] = useState('');
    const [payment, setPayment] = useState('');
    const [roundingAmount, setRoundingAmount] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [salesCount, setSalesCount] = useState();
    const [loading, setLoading] = useState(true);
    const invoiceNo = nextTenantNumber(tenantNumbering.Sales_Invoice_Prefix, salesCount?.result, 6);


    const totalRef = useRef('');
    const discountRef = useRef();
    const grandTotalRef = useRef();
    const paymentRef = useRef();
    const dueAmountRef = useRef();
    const discountTypeRef = useRef();

    // const totalRef = useRef('');
    const invoiceRef = useRef('');
    const dateRef = useRef('')
    const beepAudioRef = useRef(null);

    const customerCodeRef = useRef('');
    const customerRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');

    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    const [productHistory, setProductHistory] = useState([]);


    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getmaincustomers')
            .then(res => res.json())
            .then(data => {
                setCustomers(data);
                setLoading(false)
            })
    }, []);
    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getsalescount')
            .then(res => res.json())
            .then(data => {
                setSalesCount(data);
                console.log(data);
                setLoading(false)
            })
    }, []);

    // useEffect(() => {
    //     if (searchTerm && filtered.length > 0) {
    //         const matchedProduct = filtered.find(product => product.code === searchTerm);
    //         if (matchedProduct) {
    //             handleAddProductToInvoice(matchedProduct);
    //         }
    //     }
    // }, [searchTerm, filtered]);



    // State to store the modified array
    const [dataArray, setDataArray] = useState(products);
    console.log(products);


    // Function to calculate the default quantity
    const calculateDefaultQuantity = (minimum) => {
        return minimum * 2;
    };

    // Function to calculate the default total
    const calculateDefaultTotal = (defaultQuantity, sell) => {
        return defaultQuantity * sell;
    };

    // Set default values for quantity and total when the component mounts
    useEffect(() => {
        setDataArray(prevDataArray => {
            return prevDataArray.map(item => {
                const defaultQuantity = 1;
                const defaultTotal = calculateDefaultTotal(defaultQuantity, item.sell);
                // const cost = parseFloat(item.purchase) * parseFloat(item.quantity); // Calculate the cost
                return {
                    ...item,
                    // cost: cost.toFixed(2), // Add the cost property
                    quantity: item.quantity || defaultQuantity,
                    total: item.total || defaultTotal,
                };
            });
        });
    }, []);

    // Updated handleInputChange function
    const handleInputChange = (index, field, value) => {
        setDataArray((prevDataArray) => {
            const newDataArray = [...prevDataArray];
            newDataArray[index] = {
                ...newDataArray[index],
                [field]: value,
            };

            newDataArray[index].total =
                //changes 5-9-25
                newDataArray[index].quantity * newDataArray[index].sell;

            // Check if quantity exceeds stock
            if (value > newDataArray[index].stock && !newDataArray[index].isExceed) {
                newDataArray[index].isExceed = true; // Set isExceed to true
            } else if (value <= newDataArray[index].stock && newDataArray[index].isExceed) {
                newDataArray[index].isExceed = false; // Set isExceed to false if quantity is within stock
            }

            // Update costHistory dynamically based on the quantity
            const updatedCostHistory = [];

            let remainingQuantity = newDataArray[index].quantity;

            for (const lotEntry of productHistory) {
                const { lot, quantity, rate } = lotEntry;

                if (remainingQuantity > quantity) {
                    // If the remaining quantity is greater than the current lot quantity
                    updatedCostHistory.push({ lot, quantity, rate });
                    remainingQuantity -= quantity;
                } else {
                    // If the remaining quantity is less than or equal to the current lot quantity
                    updatedCostHistory.push({ lot, quantity: remainingQuantity, rate });
                    newDataArray[index].rate = rate; // Update the rate in the main array
                    newDataArray[index].lot = lot;  // Update the lot in the main array
                    break; // Exit the loop as we found the appropriate lot
                }
            }

            newDataArray[index].costHistory = updatedCostHistory;

            // Calculate the average cost based on the updated costHistory
            const totalCost = updatedCostHistory.reduce((totalCost, entry) => {
                return totalCost + entry.quantity * entry.rate;
            }, 0);

            const averageCost = totalCost / newDataArray[index].quantity;

            // Assign the average cost to the purchase property
            newDataArray[index].purchase = averageCost;
            // newDataArray[index].total = totalCost;

            return newDataArray;
        });
    };

    // Function to remove an item from the dataArray
    const handleRemoveItem = index => {
        setDataArray(prevDataArray => {
            const newDataArray = [...prevDataArray];
            newDataArray.splice(index, 1);
            return newDataArray;
        });
    };
    const totalValue = dataArray.reduce((total, item) => total + (item.total || 0), 0);
   

    // New

    const handleAddProductToInvoice = (product) => {
    const url = `https://servers.thakurgaonexpress.com/rupkotha/getpurchaselot?code=${product.code}`;
    fetch(url)
        .then(res => res.json())
        .then(data => {
            setProductHistory(data);

            const existingProductIndex = dataArray.findIndex((item) => item._id === product._id);

            if (existingProductIndex !== -1) {
                // Already exists → update qty & total by SELL
                const updatedDataArray = [...dataArray];
                updatedDataArray[existingProductIndex].quantity += 1;
                updatedDataArray[existingProductIndex].total =
                    updatedDataArray[existingProductIndex].quantity * updatedDataArray[existingProductIndex].sell; // ✅ SELL, not purchase

                setDataArray(updatedDataArray);
            } else {
                // New product → default 1 qty × SELL
                setDataArray((prevDataArray) => {
                    const defaultQuantity = 1;
                    const defaultTotal = calculateDefaultTotal(defaultQuantity, product.sell); // ✅ SELL from product

                    const newCostHistory = [
                        {
                            lot: data[0]?.lot,
                            quantity: 1,
                            rate: data[0]?.rate, // ✅ purchase info
                        },
                    ];

                    const isExceed = defaultQuantity > product.stock;

                    return [
                        ...prevDataArray,
                        {
                            ...product,
                            quantity: defaultQuantity,
                            total: defaultTotal,  // ✅ based on SELL
                            rate: data[0]?.rate,  // keep purchase cost separately
                            costHistory: newCostHistory,
                            isExceed,
                        },
                    ];
                });
            }

            setIsSearching(false);
            setSearchTerm('');

            if (beepAudioRef.current) {
                beepAudioRef.current.play();
            }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
};



    const handleDiscount = (event) => {
        const discount = parseFloat(event?.target?.value);
        const type = discountTypeRef.current.value;

        if (type === '%') {
            setDiscountAmount(total / 100 * discount)
        } else {
            setDiscountAmount(discount);
        }
        setIsDiscount(true);
    }

    const handleRounding = (event) => {
        const amount = parseFloat(event?.target?.value);
        setRoundingAmount(amount);
        setIsDiscount(true);
    }
    const handlePayment = (event) => {
        const payment = parseInt(event?.target?.value);
        setPayment(payment);
        setIsPayment(true);
        setIsDiscount(true);
    }

    const handleSubmitSales = () => {
        const salesInvoice = invoiceRef.current.value;
        const salesDate = dateRef.current.value;
        const customerCode = customerCodeRef.current.innerText;
        const salesCustomer = customerRef.current.innerText;
        const salesAddress = addressRef.current.innerText;
        const salesPhone = phoneRef.current.innerText;
        const salesOpening = parseFloat(openingRef.current.innerText);
        const totalAmount = parseInt(totalRef.current.innerText);
        const discount = discountAmount + roundingAmount;
        const grandTotal = parseInt(grandTotalRef.current.value);
        const paymentdata = parseInt(paymentRef.current.value);
        const payment = paymentdata ? parseInt(paymentRef.current.value) : 0;

        const isAdvance = payment === 0 & grandTotal <= Math.abs(salesOpening) ? true : false;
        const isPaid = payment + Math.abs(salesOpening) >= grandTotal ? true : false;

        const dueData = parseInt(dueAmountRef.current.value)
        const dueAmount = dueData ? parseInt(dueAmountRef.current.value) : 0;

        const user = userAc?.email.split('@')[0];
        let currentDate = new Date(salesDate);
        let monthName = currentDate.toLocaleString('default', { month: 'long' });
        let yearName = currentDate.toLocaleString('default', { year: 'numeric' });
        const month = monthName + " " + yearName;
        const type = 'Pos';
        const paid = dueAmount === 0 ? true : isAdvance === true ? true : isPaid ? true : false;

        const data = {
            products: dataArray, salesInvoice, salesDate, customerCode, salesCustomer, salesAddress,
            salesPhone, salesOpening, totalAmount, discount, fixedDis: discountAmount ? discountAmount : 0,
            roundingDis: roundingAmount ? roundingAmount : 0, grandTotal, payment, user, dueAmount, type, month, paid
        }


        fetch('https://servers.thakurgaonexpress.com/rupkotha/sales', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data),
        })
            .then(res => res.json())
            .then(data => {
                toast.success('Sales Added Successfull')
                navigate(isMobileCheckout ? '/mobile/managedefaultsales' : '/managedefaultsales')
                // navigate(`/managedefaultsales?invoice=${invoiceNo}`)
                setTimeout(() => { window.location.reload(); }, 2000);
            })

    }



    const total = dataArray.reduce((total, currentValue) => total + parseFloat(currentValue?.total), 0);

    console.log(dataArray);

    if (loading) {
        return <Loader />
    }
    const isAnyExceed = dataArray.some(item => item.isExceed);

    const checkoutGrandTotal = isDiscount === true ? (total - discountAmount - roundingAmount).toFixed(2) : total.toFixed(2);
    const checkoutDueAmount = isDiscount === false ? total.toFixed(2) : ((total - discountAmount - roundingAmount) - payment).toFixed(2);

    if (isMobileCheckout) {
        return <div className="mobile-sale-checkout">
            <header className="mobile-sale-checkout__hero">
                <div><p className="mobile-sale-checkout__eyebrow"><FiShoppingBag />Touch POS checkout</p><h1>New POS sale</h1><p>Invoice {invoiceNo}</p></div>
                <Link className="mobile-sale-checkout__home" to="/mobile" aria-label="Return to mobile dashboard"><FiArrowLeft /></Link>
            </header>

            <section className="mobile-sale-checkout__section">
                <div className="mobile-sale-checkout__section-head"><h2><FiUser />Customer</h2><small>Tap to search</small></div>
                <div className="mobile-sale-checkout__customer-picker"><CustomerList customers={customers} handleSalesDetails={() => undefined} /></div>
                <div className="mobile-sale-checkout__customer-summary">
                    <div className="mobile-sale-checkout__customer-card"><small>Selected customer</small><strong ref={customerRef}>{posCustomer?.name || 'Walking Customer'}</strong><span><span ref={customerCodeRef}>{posCustomer?.code || '00001'}</span> · <span ref={phoneRef}>{posCustomer?.phone || 'No phone'}</span></span><span ref={addressRef} className="hidden">{posCustomer?.address || 'N/A'}</span></div>
                    <div className="mobile-sale-checkout__due-card"><small>Previous due</small><strong ref={openingRef}>{posCustomer?.due ? Number(posCustomer.due).toFixed(2) : '0.00'}</strong></div>
                </div>
            </section>

            <section className="mobile-sale-checkout__section">
                <div className="mobile-sale-checkout__section-head"><h2><FiCalendar />Sale details</h2><small>{dataArray.length} item{dataArray.length === 1 ? '' : 's'}</small></div>
                <div className="mobile-sale-checkout__meta-grid">
                    <div className="mobile-sale-checkout__field"><label>Select date</label><input ref={dateRef} type="date" defaultValue={today} required /></div>
                    <div className="mobile-sale-checkout__field"><label>Invoice number</label><input ref={invoiceRef} {...(tenantNumbering.Auto_Sales_Invoice ? { value: invoiceNo, readOnly: true } : { defaultValue: '' })} placeholder="Invoice number" required /></div>
                </div>
                <div className="mobile-sale-checkout__search"><FiSearch /><input onChange={handleSearchTermChange} value={searchTerm || ''} type="text" placeholder="Scan barcode or search product" className="mobile-sale-checkout__search-input" /></div>
                {isSearching && <div className="mobile-sale-checkout__results">{isLoading ? <div className="mobile-sale-checkout__empty">Searching available products…</div> : filtered?.length ? filtered.map((product) => <button type="button" key={product._id || product.code} className="mobile-sale-checkout__product-result" onClick={() => handleAddProductToInvoice(product)}><div><strong>{product.name}</strong><small>{product.code} · Stock {product.stock}</small></div><span>+</span></button>) : <div className="mobile-sale-checkout__empty">No available product matches this search.</div>}</div>}
            </section>

            <section className="mobile-sale-checkout__section">
                <div className="mobile-sale-checkout__section-head"><h2><FiPackage />Cart</h2><small>Total {totalValue.toFixed(2)}</small><span ref={totalRef} className="hidden">{totalValue.toFixed(2)}</span></div>
                <div className="mobile-sale-checkout__cart">{dataArray.length === 0 ? <div className="mobile-sale-checkout__empty">Scan a barcode or search for a product to begin this sale.</div> : dataArray.map((product, index) => <article key={product._id || `${product.code}-${index}`} className="mobile-sale-checkout__item">
                    <div className="mobile-sale-checkout__item-top"><div><strong title={`Available stock: ${product.stock}`}>{product.name}</strong><small>{product.code} · {product.unit || 'Unit'} · Available {product.stock}</small></div><button type="button" className="mobile-sale-checkout__remove" onClick={() => handleRemoveItem(index)} aria-label={`Remove ${product.name}`}><FiX /></button></div>
                    <div className="mobile-sale-checkout__item-controls"><label>Quantity<input type="number" value={product.quantity || 0} onChange={(event) => handleInputChange(index, 'quantity', parseInt(event.target.value || 0, 10))} /></label><label>Sale rate<input type="number" value={product.sell || 0} onChange={(event) => handleInputChange(index, 'sell', parseFloat(event.target.value || 0))} /></label><strong className="mobile-sale-checkout__line-total">{Number(product.total || 0).toFixed(2)}</strong></div>
                </article>)}</div>
            </section>

            <section className="mobile-sale-checkout__summary">
                <div className="mobile-sale-checkout__summary-top"><div><small>Grand total</small><strong>{checkoutGrandTotal}</strong><input ref={grandTotalRef} className="hidden" value={checkoutGrandTotal} readOnly /></div><span>{dataArray.length} cart item{dataArray.length === 1 ? '' : 's'}</span></div>
                <div className="mobile-sale-checkout__adjustments">
                    <div className="mobile-sale-checkout__field"><label>Discount type</label><select ref={discountTypeRef} defaultValue="%"><option value="%">Percentage (%)</option><option value="Fixed">Fixed amount</option></select></div>
                    <div className="mobile-sale-checkout__field"><label>Discount</label><input ref={discountRef} onChange={handleDiscount} type="number" inputMode="decimal" placeholder="0.00" /></div>
                    <div className="mobile-sale-checkout__field"><label>Rounding</label><input onChange={handleRounding} type="number" inputMode="decimal" placeholder="0.00" /></div>
                    <div className="mobile-sale-checkout__field"><label>Current total</label><input value={checkoutGrandTotal} readOnly /></div>
                </div>
                <div className="mobile-sale-checkout__payment-row"><div className="mobile-sale-checkout__pay-card"><small>Cash payment</small><input ref={paymentRef} onChange={handlePayment} type="number" inputMode="decimal" placeholder="0.00" /></div><div className="mobile-sale-checkout__pay-card"><small>Due amount</small><input ref={dueAmountRef} value={checkoutDueAmount} readOnly /></div></div>
                {isAnyExceed && <p className="mobile-sale-checkout__stock-warning">One or more quantities exceed available stock. Reduce them before completing this sale.</p>}
                <button type="button" onClick={handleSubmitSales} disabled={isAnyExceed || dataArray.length === 0} className="mobile-sale-checkout__submit">Complete sale · {checkoutGrandTotal}</button>
            </section>
        </div>;
    }


    return (
        <div className="tenant-page">
            {/* <audio ref={beepAudioRef} src={beep} /> */}
            {/* <audio ref={beepErrorRef} src={error} /> */}
            <h1 className="tenant-page__heading tenant-page__heading--single">POS Sale</h1>
            <div className='flex'>
                <CustomerList customers={customers} />
            </div>
            <div className='transaction-panel flex flex-col lg:flex-row justify-start items-center gap-2 mt-4'>
                <div className='lg:col-span-4 mt-7'>
                    <table class="table w-full mx-auto">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Select Date</th>
                                <th className='bg-primary text-white normal-case'>Invoice No</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            <tr className=''>
                                <td> <input ref={dateRef} type="date" defaultValue={today} placeholder="Date" class="rounded-lg text-center text-xs bg-white p-3 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required /></td>
                                <td><input ref={invoiceRef} {...(tenantNumbering.Auto_Sales_Invoice ? { value: invoiceNo, readOnly: true } : { defaultValue: '' })} type="text" placeholder="Type Invoice" class="rounded-lg text-xs text-center bg-white p-3 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='lg:col-span-7 overflow-x-auto w-full lg:w-auto lg:overflow-visible'>
                    <div className='sm:overflow-x-auto'>
                        <table class="table mx-auto text-xs">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Customer Code</th>
                                    <th className='bg-primary text-white normal-case'>Customer Name</th>
                                    <th className='bg-primary text-white normal-case'>Customer Address</th>
                                    <th className='bg-primary text-white normal-case'>Mobile No</th>
                                    <th className='bg-primary text-white normal-case'>Previews Due</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td ref={customerCodeRef} className='h-8'>{posCustomer?.code ? posCustomer?.code : '00001'}</td>
                                    <td ref={customerRef} className='h-8'>{posCustomer?.name ? posCustomer?.name : 'Walking Customer'}</td>
                                    <td ref={addressRef}>{posCustomer?.address ? posCustomer?.address : 'N/A'}</td>
                                    <td ref={phoneRef}>{posCustomer?.phone ? posCustomer?.address : 'N/A'}</td>
                                    <td ref={openingRef}>{posCustomer?.due ? (posCustomer?.due)?.toFixed(2) : '0.00'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className='flex justify-center lg:justify-start items-center my-4'>
                <div class="form-control w-60 mx-auto lg:mx-px">
                    <input onChange={handleSearchTermChange} value={searchTerm} type="text" placeholder="Scan Code/Search Product" class="input text-xs input-bordered border-dark-purple w-full max-w-xs" />
                </div>
            </div>

            <hr />
            <div style={isSearching ? {} : { visibility: 'hidden' }} className={`transaction-search-results grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 p-2 ${isSearching ? 'h-60' : "h-8"} w-80 overflow-auto`}>
                {
                    filtered?.map(product =>
                        <label for="update-modal" onClick={() => handleAddProductToInvoice(product)} style={{ width: '300px', height: '50px' }} className={`text-xs p-3 te shadow-md flex justify-left items-center rounded-lg font-bold cursor-pointer`}>{product?.code}-{product?.name}</label>)
                }
            </div>
            <div className='lg:grid lg:grid-cols-12 gap-2 h-screen'>
                <div className='overflow-auto lg:col-span-10 text-xs z-30 mb-4'>
                    <table class="table w-1/2 mx-auto text-xs">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>SL#</th>
                                <th className='bg-primary text-white normal-case'>Product Code</th>
                                <th className='bg-primary text-white normal-case w-20'>Product Name</th>
                                <th className='bg-primary text-white normal-case'>Sale Quantity</th>
                                <th className='bg-primary text-white normal-case'>Unit</th>
                                <th className='bg-primary text-white normal-case'>Sale Rate</th>
                                <th className='bg-primary text-white normal-case'>Total</th>
                                <th className='bg-primary text-white normal-case'>Action</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            {
                                dataArray?.map((product, index) => <tr key={product._id} className='hover'>
                                    <td className='h-8'>{index + 1}</td>
                                    <td className='h-8'>{product?.code}</td>
                                    <td title={`Available Stock: ${dataArray[index].stock}`} className='text-xs w-20'>{product?.name}</td>
                                    <td><input
                                        type="number"
                                        className={`border border-gray-300 px-2 py-1 rounded-md w-16 text-center ${dataArray[index].isExceed ? 'text-primary' : ''}`}
                                        value={product.quantity || 0}
                                        onChange={e => handleInputChange(index, 'quantity', parseInt(e.target.value))}
                                    /></td>
                                    <td className='h-8 w-8'>{product?.unit}</td>
                                    <td> <input
                                        type="number"
                                        className="border border-gray-300 px-2 py-1 rounded-md w-20 text-center"
                                        value={product.sell || 0}
                                        onChange={e => handleInputChange(index, 'sell', parseFloat(e.target.value))}
                                    /></td>
                                    <td><input type="number" value={(product.total)?.toFixed(2) || 0} placeholder="Type here" className="input text-xs input-bordered text-center h-8 w-28 max-w-lg" readOnly /></td>
                                    <td> <button
                                        className="btn btn-sm"
                                        onClick={() => handleRemoveItem(index)}
                                    >
                                        Remove
                                    </button> </td>
                                </tr>)
                            }

                        </tbody>
                        <tfoot className='text-center h-2'>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className='text-sm font-bold'>Total</td>
                                <td ref={totalRef} className='text-sm font-bold'>{totalValue.toFixed(2)}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Discount</td>
                                <td>
                                    <select ref={discountTypeRef} defaultValue='' class="rounded-lg text-center text-textPrimary text-xs  w-full h-8 max-w-xs" required>
                                        <option selected>%</option>
                                        <option>Fixed</option>
                                    </select>
                                </td>
                                <td> <input ref={discountRef} onChange={handleDiscount} type="number" placeholder="Type Discount" className="input input-bordered text-center text-xs w-28 h-8 mx-auto max-w-lg" /></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Rounding</td>
                                <td>
                                </td>
                                <td> <input onChange={handleRounding} type="number" placeholder="Type Discount" className="input input-bordered text-center text-xs w-28 h-8 mx-auto max-w-lg" /></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
              <div className="overflow-auto lg:col-span-2 ml-20 lg:ml-0">
    <div
        style={{ height: "400px" }}
        className="transaction-panel--total w-48 text-xs text-center flex flex-col items-center"
    >
        {/* Grand Total */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case text-sm mb-2 font-medium">
                Grand Total
            </label>

            <input
                ref={grandTotalRef}
                type="number"
                value={
                    isDiscount === true
                        ? (
                            total -
                            discountAmount -
                            roundingAmount
                        ).toFixed(2)
                        : total.toFixed(2)
                }
                placeholder="Type here"
                className="input text-xs input-bordered text-center w-36 mx-auto max-w-lg"
            />
        </div>

        {/* Cash Payment */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case text-sm mb-2 font-medium">
                Cash Payment
            </label>

            <input
                ref={paymentRef}
                onChange={handlePayment}
                type="number"
                placeholder="Type Payment"
                className="input text-xs input-bordered text-center w-36 mx-auto max-w-lg"
            />
        </div>

        {/* Due Amount */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case text-sm mb-2 font-medium">
                Due Amount
            </label>

            <div className="flex flex-col items-center gap-3">
                <input
                    ref={dueAmountRef}
                    type="number"
                    value={
                        isDiscount === false
                            ? total.toFixed(2)
                            : (
                                total -
                                discountAmount -
                                roundingAmount -
                                payment
                            ).toFixed(2)
                    }
                    placeholder="Type here"
                    className="input text-xs input-bordered text-center w-36 max-w-lg"
                />

                <button
                    onClick={handleSubmitSales}
                    disabled={isAnyExceed}
                    className="btn btn-md text-white"
                >
                    Add Sales
                </button>
            </div>
        </div>
    </div>
</div>
            </div>
        </div>
    );
};

export default AddPosSales;
